import { styled } from 'opensolar-ui'
import { MAX_HEIGHT } from './hardware/hooks/useOneQuarterHeightAuthority'

export const Column = styled('div', { name: 'Column' })({
  display: 'flex',
  flexDirection: 'column',
})

export const RowCentered = styled('div', { name: 'RowCentered' })({
  display: 'flex',
  alignItems: 'center',
})

export const InputRow = styled('div', { name: 'InputRow' })({
  display: 'flex',
  gap: 10,
})

export const InputWrapper = styled('div', { name: 'InputWrapper' })({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
})

export const ContentBg = styled('div', { name: 'ContentBg' })(({ theme }) => ({
  backgroundColor: theme.palette.info.light,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

export const SectionCardTop = styled('div', { name: 'SectionCardTop' })(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  borderBottom: theme.mixins.borderStandard.border,
  display: 'flex',
  alignItems: 'center',
}))

export const iconStyles = {
  paddingLeft: 20,
  paddingRight: 10,
  display: 'flex',
  alignItems: 'center',
}

export const SectionWrapper = styled('div', { name: 'SectionWrapper' })({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'stretch',
  padding: 40,
  width: '100%',
  maxWidth: 1440,
  boxSizing: 'border-box',
  gap: 30,
  '& > *': { maxWidth: '100%' },
})

export const StyledSectionWrapper = styled('div', { name: 'StyledSectionWrapper' })<{
  last: boolean
  isNewManageLayout?: boolean
  fillHeight?: boolean
}>(({ last, theme, isNewManageLayout, fillHeight }) => ({
  height: fillHeight ? '100%' : 'auto',
  backgroundColor: theme.palette.common.white,
  padding: isNewManageLayout ? 0 : 20,
  ...(last
    ? { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 }
    : { borderRadius: 0, borderBottom: theme.mixins.borderStandard.border }),
  ...(isNewManageLayout && {
    borderRadius: 8,
  }),
}))

export const StyledSectionHeader = styled('p')({
  fontSize: 16,
  margin: 0,
  fontWeight: 500,
  padding: 16,
  paddingLeft: 0,
})

export const OneQuarterWidthSection = styled('div', { name: 'OneQuarterWidthSection' })<{
  hasOnlyOneElement?: boolean
}>(({ hasOnlyOneElement }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: hasOnlyOneElement ? 'calc(50% - 15px)' : 'calc(33% - 15px)',
  flex: hasOnlyOneElement ? '0 0 calc(50% - 15px)' : '0 0 calc(33% - 15px)',
  minWidth: 300,
  height: hasOnlyOneElement ? 400 : 'auto',
  maxHeight: MAX_HEIGHT,
  alignSelf: 'flex-start',
  gap: '20px',

  [`@media (max-width: ${1430}px) and (min-width: ${865}px)`]: {
    minWidth: 0,
  },

  [`@media (max-width: ${864}px)`]: {
    width: '100%',
    flex: '0 0 100%',
    flexDirection: 'column',
    gap: '20px',
    minWidth: 0,
  },
}))

export const ThreeQuarterWidthSection = styled('div', { name: 'ThreeQuarterWidthSection' })<{
  cashflowOrHardwareNotVisible?: boolean
  isMobile?: boolean
}>(({ cashflowOrHardwareNotVisible }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: cashflowOrHardwareNotVisible ? '100%' : 'calc(67% - 15px)',
  flex: cashflowOrHardwareNotVisible ? '0 0 100%' : '0 0 calc(67% - 15px)',
  minWidth: 300,
  minHeight: cashflowOrHardwareNotVisible ? 550 : 'auto',
  height: 'var(--one-quarter-height, auto)',
  maxHeight: MAX_HEIGHT,
  overflowY: 'auto',
  alignSelf: 'flex-start',

  [`@media (max-width: ${1430}px) and (min-width: ${865}px)`]: {
    minWidth: 0,
  },
  [`@media (max-width: ${864}px)`]: {
    width: '100%',
    flex: '0 0 100%',
    minWidth: 0,
    height: 'auto',
  },
}))

export const HalfWidthSection = styled('div', { name: 'HalfWidthSection' })({
  display: 'flex',
  flexDirection: 'column',
  width: '40%',
  flexGrow: 1,
  minWidth: 300,
  maxHeight: 400,
})

export const SectionCardBottom = styled('div', { name: 'SectionCardBottom' })(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 20,
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  height: 'auto',
  maxHeight: '100%',
}))

export const WidgetWrapper = styled('div', { name: 'WidgetWrapper' })({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  alignItems: 'stretch',
})
